import * as React from "react";
import { Component } from "react";
import { connect } from "react-redux";
import { IRootState } from "../../../store";
import DispatchProps from "../../../utils/DispatchProps";
import { Icon } from "office-ui-fabric-react";

interface HelpBoxProps {
    Icon?: string;
    TitleText: string;
    HelpBoxText: string | JSX.Element;
}

interface HelpBoxState {
}

class HelpBox extends Component<HelpBoxProps & DispatchProps, HelpBoxState> {

    constructor(props: HelpBoxProps & DispatchProps) {
        super(props);
        this.state = {
        };
    }

    public render(): JSX.Element {
        return (
            <div className={"flex-row flex--justify-content-center p-1rem"}>
                <div className="help-box-item help-box-item--row help-box-item--wide">

                    <div className={"flex-column flex-item--flex-1"}>
                        <div className="help-box-item__icon">
                            <Icon iconName={this.props.Icon} className="" />
                        </div>
                        <span className="help-box-item__title">{this.props.TitleText}</span>
                        <span className="help-box-item__description">{this.props.HelpBoxText}</span>
                    </div>
                </div>
            </div>
        );
    }
}




export default connect(
    (state: IRootState, ownProps: { Icon: string, TitleText: string, HelpBoxText: string | JSX.Element }): HelpBoxProps => {

        return {
            Icon: ownProps.Icon,
            TitleText: ownProps.TitleText,
            HelpBoxText: ownProps.HelpBoxText
        };
    }
)(HelpBox);